import type { Reducer } from 'umi';

// 用户信息类型
export type TUserInfo = {
  uid?: string;
  username?: string;
  nameEn?: string;
  realname?: string;
};

export interface UserModelType {
  namespace: 'userInfo';
  state: TUserInfo;
  reducers: {
    save: Reducer<TUserInfo>;
  };
}

const userInfoModal: UserModelType = {
  namespace: 'userInfo',
  state: {
    uid: undefined,
    username: undefined,
    realname: undefined,
    nameEn: undefined,
  },
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
};
export default userInfoModal;
